import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";
// import Style from "./style.module.css";
import { GlobalContext } from "../../../../context/Context";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Tooltip from "../../../../component/ui/tooltip";
import { Loader2, Trash2, X } from "lucide-react";
import Select from "react-select";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
  FormLineBreak,
} from "../../../../component/form/form-layout";
import { set } from "date-fns";

const stripHtml = (html) => (html || "").replace(/<[^>]*>?/gm, "");

function convertMetaObjectToArray(metaObj = {}) {
  return Object.entries(metaObj).map(([key, value]) => ({
    meta_key: key,
    meta_value: value,
  }));
}

const AddUpdateBrand = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  brandData = null,
  Style,
}) => {
  console.log(brandData);
  const { state } = useContext(GlobalContext);
  const apiCall = useApiCall();

  const [logoType, setLogoType] = useState("url");
  const [imagePreview, setImagePreview] = useState(null);

  const DeleteField = (index) => {
    const newFields = formik.values.extra_meta.filter((_, i) => i !== index);
    formik.setFieldValue("extra_meta", newFields);
  };

  useEffect(() => {
    if (brandData.brandsid) {
      formik.setFieldValue("brandname", brandData?.brandname);
      formik.setFieldValue("brandurl", brandData?.brandurl);
      formik.setFieldValue("logo", brandData?.logo);
      formik.setFieldValue("order_sort_id", brandData?.order_sort_id);

      formik.setFieldValue("address", brandData?.meta?.address);
      formik.setFieldValue("phone", brandData?.meta?.phone);
      formik.setFieldValue("email", brandData?.meta?.email);
      formik.setFieldValue(
        "extra_meta",
        convertMetaObjectToArray(brandData?.meta)
      );
    }
  }, []);

  const primaryFields = ["address", "phone", "email"];

  const validationSchema = yup.object({
    brandname: yup.string().required("This Field is Required"),
    brandurl: yup.string().required("This Field is Required"),
    order_sort_id: yup
      .string()
      .required("This Field is Required")
      .min(3, "Minimum 3 characters")
      .max(5, "Maximum 3 characters"),
    address: yup.string().required("This Field is Required"),
    phone: yup
      .string()
      .required("Phone number is required")
      .matches(/^\+?[0-9\s\-\(\)]+$/, "Invalid phone number format"),
    email: yup.string().required("This Field is Required"),
    logo: yup.string().when([], {
      is: () => logoType == "url", // check your state here
      then: (schema) => schema.required("This Field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    logo_file: yup.mixed().when([], {
      is: () => logoType == "upload", // check your state here
      then: (schema) => schema.required("This Field is Required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  // Formik
  const formik = useFormik({
    // enableReinitialize: true,
    initialValues: {
      brandname: "",
      brandurl: "",
      order_sort_id: "",
      logo: "",
      logo_file: "",
      address: "",
      phone: "",
      email: "",
      extra_meta: [],
    },
    validationSchema,
    // validationContext: { logoType },
    onSubmit: async (values) => {
      let extra_meta = values.extra_meta.map((item) => ({
        key: item.meta_key,
        value: item.meta_value,
      }));

      if (brandData?.brandsid) {
        let newArr = [];
        for (let i = 0; i < extra_meta?.length; i++) {
          if (extra_meta[i]?.key == "address") {
            newArr.push({ key: extra_meta[i]?.key, value: values?.address });
          } else if (extra_meta[i]?.key == "phone") {
            newArr.push({ key: extra_meta[i]?.key, value: values?.phone });
          } else if (extra_meta[i]?.key == "email") {
            newArr.push({ key: extra_meta[i]?.key, value: values?.email });
          } else {
            newArr?.push(extra_meta[i]);
          }
        }
        extra_meta = [...newArr];
      } else {
        extra_meta.push({
          key: "address",
          value: values.address,
        });

        extra_meta.push({
          key: "email",
          value: values.email,
        });

        extra_meta.push({
          key: "phone",
          value: values.phone,
        });
      }

      let data;

      if (logoType === "upload") {
        const formData = new FormData();
        formData.append("logo_file", values.logo_file);
        formData.append("logo", values.logo);
        formData.append("brandname", values.brandname);
        formData.append("brandurl", values.brandurl);
        formData.append("order_sort_id", values.order_sort_id);
        extra_meta?.forEach((extraData, index) => {
          formData.append(`extra_meta[${index}][key]`, extraData.key);
          formData.append(`extra_meta[${index}][value]`, extraData.value);
        });
        // formData.append("extra_meta", JSON.stringify(extra_meta));

        // ...baaki fields
        data = formData;
      } else {
        data = {
          brandname: values.brandname,
          brandurl: values.brandurl,
          order_sort_id: values.order_sort_id,
          logo: values.logo,
          logo_file: "",
          extra_meta: extra_meta,
        };
      }

      console.log("data", data);
      console.log("extra_meta", extra_meta);

      try {
        const url = brandData?.brandsid
          ? `brands/update-brand/${brandData.brandsid}`
          : "brands/add-brand";
        const apiRes = await apiCall({
          method: "post",
          url,
          data,
        });
        onSubmit(apiRes?.message || "Brand Add successfully");
        formik.resetForm();
        onClose();
        setImagePreview(null);
      } catch (error) {
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.responseMessage ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  const AddField = () => {
    console.log(formik.values);
    let newFields = [
      ...formik.values.extra_meta,
      { meta_key: "", meta_value: "" },
    ];
    formik.setFieldValue("extra_meta", newFields);
  };

  const handleUploadImage = (image) => {
    const file = image;
    if (file) {
      formik.setFieldValue("logo", "");
      formik.setFieldValue("logo_file", file);

      // yahan dummy URL banate hain 👇
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
      console.log("Image Preview", imagePreview);
    }
  };

  const removeImage = () => {
    setImagePreview(null);
    formik.setFieldValue("logo_file", "");
  };

  useEffect(() => {
    const textarea = document.querySelector("textarea[name='features']");
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    }
  }, [formik.values.features]);

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        {/* Body */}
        <div className={Style.modal_body}>
          <FormArea>
            {/* Brand Name */}
            <FeildWraper width="100%">
              <FormLabel required>Name</FormLabel>
              <input
                type="text"
                name="brandname"
                value={formik.values.brandname}
                onChange={formik.handleChange}
                placeholder="Brand Name"
              />

              {formik.touched.brandname && formik.errors.brandname && (
                <FeildError>{formik.errors.brandname}</FeildError>
              )}
            </FeildWraper>

            {/* Brand Url */}

            <FeildWraper width="100%">
              <FormLabel required>Brand Url</FormLabel>
              <input
                type="url"
                name="brandurl"
                value={formik.values.brandurl}
                onChange={formik.handleChange}
                placeholder="Brand Url"
              />

              {formik.touched.brandurl && formik.errors.brandurl && (
                <FeildError>{formik.errors.brandurl}</FeildError>
              )}
            </FeildWraper>

            {/* order_sort_id */}
            <FeildWraper>
              <FormLabel required>Order Sort ID</FormLabel>
              <input
                type="text"
                name="order_sort_id"
                value={formik.values.order_sort_id}
                onChange={formik.handleChange}
                placeholder="Order Sort Id"
              />
              {formik.touched.order_sort_id && formik.errors.order_sort_id && (
                <FeildError>{formik.errors.order_sort_id}</FeildError>
              )}
            </FeildWraper>

            {/* Address */}
            <FeildWraper>
              <FormLabel required>Address</FormLabel>
              <input
                type="text"
                name="address"
                value={formik.values.address}
                onChange={formik.handleChange}
                placeholder="Address"
              />
              {formik.touched.address && formik.errors.address && (
                <FeildError>{formik.errors.address}</FeildError>
              )}
            </FeildWraper>

            {/* Email */}
            <FeildWraper>
              <FormLabel required>Email</FormLabel>
              <input
                type="text"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                placeholder="Email"
              />
              {formik.touched.email && formik.errors.email && (
                <FeildError>{formik.errors.email}</FeildError>
              )}
            </FeildWraper>

            {/* Phone */}
            <FeildWraper>
              <FormLabel required>Phone</FormLabel>
              <input
                type="tel"
                name="phone"
                value={formik.values.phone}
                onChange={formik.handleChange}
                placeholder="Phone"
                pattern="^\+?[0-9\s\-\(\)]*$"
              />
              {formik.touched.phone && formik.errors.phone && (
                <FeildError>{formik.errors.phone}</FeildError>
              )}
            </FeildWraper>

            {formik.values.logo || formik.values.logo_file ? null : (
              <div className="w-full px-3 flex flex-col gap-2">
                <div>
                  <p className="!font-sm !font-medium !leading-5  !text-[#1E2E54]">
                    Logo
                  </p>
                </div>
                <div className="flex gap-10 items-center text-sm">
                  <label className="flex gap-1 font-sm font-medium leading-5  text-[#1E2E54]">
                    <input
                      type="radio"
                      name="logoType"
                      value="upload"
                      checked={logoType === "upload"}
                      onChange={() => setLogoType("upload")}
                    />
                    Upload Logo
                  </label>

                  <label className="flex gap-1 font-sm font-medium leading-5  text-[#1E2E54]">
                    <input
                      type="radio"
                      name="logoType"
                      value="url"
                      checked={logoType === "url"}
                      onChange={() => setLogoType("url")}
                    />
                    Logo URL
                  </label>
                </div>
              </div>
            )}

            {logoType === "upload" ? (
              <FeildWraper width="100%">
                <FormLabel required>Upload Logo</FormLabel>
                {/* <input
                  type="file"
                  name="logoFile"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    formik.setFieldValue("logo", file);
                  }}
                /> */}
                <label
                  onDrop={(e) => {
                    e.preventDefault();
                    handleUploadImage(e.dataTransfer.files?.[0]);
                  }}
                  onDragOver={(e) => e.preventDefault()}
                  className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                >
                  <p className="text-gray-600 font-medium">
                    Drag & Drop files here
                  </p>
                  <p className="text-sm text-gray-400">or click to browse</p>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      handleUploadImage(e.target.files?.[0]);
                    }}
                    className="hidden"
                  />
                </label>
                {imagePreview && (
                  <span className="relative  inline-block w-fit">
                    <img
                      src={imagePreview}
                      alt="Preview"
                      className="h-20 w-20 rounded-md relative border border-gray-500 "
                      onError={(e) => {
                        e.target.classList.add("hidden");
                      }}
                    />
                    <div
                      className="absolute -top-1  -right-2  rounded transition-all duration-300  z-20 bg-white hover:bg-gray-400 cursor-pointer"
                      onClick={() => {
                        removeImage();
                      }}
                    >
                      <X size={20} color="#eb1e1e" />
                    </div>
                  </span>
                )}
                {formik.touched.logo_file && formik.errors.logo_file && (
                  <FeildError>{formik.errors.logo_file}</FeildError>
                )}
              </FeildWraper>
            ) : (
              <FeildWraper width="100%">
                <FormLabel required>Logo URL</FormLabel>
                <input
                  type="text"
                  name="logo"
                  value={formik.values.logo}
                  onChange={formik.handleChange}
                  placeholder="Image Url"
                />
                {formik.touched.logo && formik.errors.logo && (
                  <FeildError>{formik.errors.logo}</FeildError>
                )}
              </FeildWraper>
            )}

            {Array.isArray(formik.values.extra_meta) &&
              formik.values.extra_meta.some(
                (field) => !primaryFields.includes(field.meta_key)
              ) && (
                <>
                  <FormLineBreak />
                  <div className="flex items-center pt-3 px-2">
                    <h1 className="text-md font-medium  py-1">
                      Additional Fields
                    </h1>
                  </div>
                </>
              )}

            <FeildWraper width="100%">
              {formik?.values?.extra_meta?.map((field, index) => {
                if (primaryFields?.includes(field?.meta_key)) {
                  return null; // Skip rendering if it's a primary field
                }

                return (
                  <div className={`w-full flex gap-3`} key={index}>
                    {/* key */}

                    <input
                      type="text"
                      name={`extra_meta[${index}].meta_key`}
                      value={formik.values.extra_meta[index].meta_key}
                      onChange={formik.handleChange}
                      placeholder="key"
                    />

                    {/* value */}

                    <input
                      type="text"
                      name={`extra_meta[${index}].meta_value`}
                      value={formik.values.extra_meta[index].meta_value}
                      onChange={formik.handleChange}
                      placeholder="value"
                    />

                    <Tooltip
                      key={`${index}-asideBottomItems`}
                      className={`${Style.Tooltip}`}
                      boxClassName={Style.TooltipBox}
                      content="Delete Field"
                      position={"bottom center"}
                    >
                      <div
                        onClick={() => DeleteField(index)}
                        className="p-3 text-red-600"
                      >
                        <Trash2 size={18} />
                      </div>
                    </Tooltip>
                  </div>
                );
              })}

              <button
                type="button"
                onClick={AddField}
                className="flex flex-start text-blue-700 font-medium   w-full p-2 text-[16px]"
              >
                + Add Field
              </button>
            </FeildWraper>
          </FormArea>
        </div>

        {/* Footer */}
        <div className={Style.modal_foot}>
          <button
            type="button"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={Style.dcmb__submit}>
            {brandData?.brandsid ? "Update" : "Apply"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUpdateBrand;
